import React from "react";

const GoogleMap = () => {
  return (
    <div className="google-map-area section text-center">
      <div className="">
        <div className="contact-map-area" data-aos="fade-up">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2852.365126387244!2d-117.90741996231777!3d33.62488588511819!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dcdfe65146336f%3A0xcf90662d9127b5b5!2s1501%20Westcliff%20Dr%2C%20Newport%20Beach%2C%20CA%2092660%2C%20USA!5e0!3m2!1sen!2s!4v1691592688922!5m2!1sen!2s"
            style={{ border: 0 }}
            className="contact-map"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default GoogleMap;
